import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { ImageGenerateRequest } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Props {
  workspaceId: number
  generationType: 'image' | 'stock_image'
  brandProfileId?: number
}

export interface Data {
  request: ImageGenerateRequest
}

export interface Variables {
  signal?: AbortSignal
}

export type Options = Omit<UseMutationOptions<Data, Error, Variables>, 'mutationFn'>

const generateImageFromBrandProfile = async ({
  workspaceId,
  generationType,
  signal,
  brandProfileId,
}: Variables & Props) => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/generate_brand_image`, {
    method: 'POST',
    body: {
      brand_profile_id: brandProfileId,
      generation_type: generationType,
    },
    signal,
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response.data
}

export const useGenerateImageFromBrandProfile = (
  { workspaceId, generationType, brandProfileId }: Props,
  options?: Options,
) => {
  return useMutation<Data, Error, Variables>(
    (variables) => generateImageFromBrandProfile({ workspaceId, brandProfileId, generationType, ...variables }),
    options,
  )
}
